"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventBuffer = void 0;
var EventBuffer_1 = require("./EventBuffer");
Object.defineProperty(exports, "EventBuffer", { enumerable: true, get: function () { return EventBuffer_1.EventBuffer; } });
